

import React from 'react';
import Subnavbody from '../props/sub-pages/Subnavbody';

function Resources() {
  return (
    <div>
      <Subnavbody video='/videos/buildings.mp4' subText='Resources'/>

    </div>
  );
}

export default Resources;
